import { Stack, usePathname } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";
import { USER_ROLES_TABS } from "app/constants/tabConstants";

export default function UserRolesLayout() {
  const pathname = usePathname();

  return (
    <PageLayout
      screenName="Audit Logs"
      className="p-dashboard"
      currentPath={pathname}
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
